<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <tooltip :value="$t('actions.downloadLinePricing.main')" position="bottom">
        <v-btn
          small
          color="primary"
          class="ml-2"
          :loading="downloadingLinePricing"
          depressed
          v-on="on"
        >
          <v-icon small>$export</v-icon>
          {{ $t('actions.download') }}
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </tooltip>
    </template>

    <v-list>
      <v-list-item
        v-if="isPricingManager || isPricingSpecialist"
        @click="downloadLinePricingHandler({ exportAG: false })"
      >
        <v-list-item-title>
          {{ $t('actions.downloadLinePricing.workpackage') }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="downloadLinePricingHandler({ exportAG: true })">
        <v-list-item-title>
          {{ $t('actions.downloadLinePricing.ag') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { useZones, useStoreGroupChains } from '@enums/feature-flags';
import featureFlagsMixin from '../mixins/featureFlags';
import numberFormats from '@enums/number-formats';
import { get } from 'lodash';

export default {
  mixins: [featureFlagsMixin],
  computed: {
    ...mapState('architectureGroup', ['downloadingLinePricing']),
    ...mapState('filters', ['architectureGroup']),
    ...mapGetters('context', ['isPricingManager', 'isPricingSpecialist']),
    ...mapState('storeGroupRelationships', ['storegroupKeyNameMap']),
    ...mapState('clientConfig', ['exportConfigs']),

    columnFormatters() {
      return {
        [this.$t('pricing.productKey')]: {
          type: get(
            this.exportConfigs,
            'exportToExcel.columnFormatter.productKeyDisplay',
            numberFormats.integer
          ),
        },
      };
    },
  },
  methods: {
    ...mapActions('architectureGroup', ['downloadLinePricing']),

    buildTranslationMap() {
      const isChainsMode = this.isFeatureFlagEnabled(useStoreGroupChains);
      const base = {
        productKeyDisplay: this.$t('pricing.productKey'),
        productName: this.$t('pricing.productDescription'),
        category: this.$t('pricing.category'),
        pricingGroup: this.$t('pricing.pricingGroup'),
        architectureGroup: this.$t('pricing.architectureGroup'),
      };

      if (!isChainsMode) {
        const toolStoreGroupTranslation = this.isFeatureFlagEnabled(useZones)
          ? { toolStoreGroupDescription: this.$t('pricing.toolStoreGroup') }
          : {};
        return {
          ...base,
          ...toolStoreGroupTranslation,
          linePricedGroupDescription: this.$t('settings.architecture.linePricingGroupHeader'),
          linePriceFactor: this.$t('settings.architecture.LinePriceFactorHeader'),
        };
      }

      const dynamic = {};
      Object.entries(this.storegroupKeyNameMap || {}).forEach(([tsgKey, abbr]) => {
        dynamic[`${tsgKey}_linePricedGroupDescription`] = `${abbr} ${this.$t(
          'settings.architecture.linePricingGroupHeader'
        )}`;
        dynamic[`${tsgKey}_linePriceFactor`] = `${abbr} ${this.$t(
          'settings.architecture.LinePriceFactorHeader'
        )}`;
      });

      return {
        ...base,
        ...dynamic,
      };
    },

    downloadLinePricingHandler({ exportAG }) {
      const translationMap = this.buildTranslationMap();

      const params = {
        translationMap,
        columnFormatters: this.columnFormatters,
      };

      if (exportAG) {
        params.architectureGroupId = this.architectureGroup;
      }

      this.downloadLinePricing(params);
    },
  },
};
</script>
